<!-- 创建时间2023/06/16 17:26:30 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：附件 -->
<template>
  <div>
    <yxtbiz-upload
      ref="bizUpload"
      isBizMixDeploy
      source="501"
      app-code="kng"
      config-key="AttachOpenConfigKey"
      module-name="knowledgefiles"
      function-name="files"
      :files-added="filesAdded"
      :on-progress="onProgress"
      :on-uploaded="onUploaded"
      :on-error="onError"
      :convert="false"
      :filters="filters"
      :disabled="disabled_"
      multipe
      md5
    >
    </yxtbiz-upload>
    <yxtbiz-upload
      ref="bizPrivateUpload"
      isBizMixDeploy
      source="501"
      app-code="kng"
      config-key="AttachConfigKey"
      module-name="knowledgefiles"
      function-name="files"
      :files-added="filesAdded"
      :on-progress="onProgress"
      :on-uploaded="onUploaded"
      :on-error="onError"
      :convert="false"
      :filters="filters"
      :disabled="disabled_"
      :isLocal="uploadConfig.privateEnv"
      :localGroupId="uploadConfig.serverGroupId"
      :transcodeOptions="transcodeOptions"
      multipe
      md5
    >
    </yxtbiz-upload>
    <yxt-button :disabled="disabled_" @click="clickUpload">
      <yxt-svg
        class="v-middle"
        width="16px"
        height="16px"
        :remote-url="`${$staticBaseUrl}ufd/407a24/kng/pc/svg/pc`"
        icon-class="upload-attachment"
      />
      {{ $t('pc_kng_lbl_upload_attachment' /*上传附件*/) }}
    </yxt-button>
    <div class="color-gray-6 mt8 lh24">
      <span class="mr2">
        {{ $t('pc_kng_lbl_upload_attachment_tip'/** 最多上传50个附件，学员观看该课程时可以下载附件，支持类型：视频/音频/文档/图片/压缩包 */) }}
      </span>
      <yxt-tooltip effect="dark" placement="bottom">
        <div slot="content">
          {{ $t('pc_kng_lbl_upload_attachment_video' /*视频格式：wmv、mp4、flv、avi、rmvb、mpg、mkv、mov，单个视频小于2G*/) }}
          <br />
          {{ $t('pc_kng_lbl_upload_attachment_audio' /*音频格式：w4v、m4a、wma、wav、mp3、amr，单个音频小于200M*/) }}
          <br />
          {{ $t('pc_kng_lbl_upload_attachment_doc' /*文档格式：doc、docx、ppt、pptx、xls、xlsx、pps、pdf，单个文档小于100M*/) }}
          <br />
          {{ $t('pc_kng_lbl_upload_attachment_img' /*图片格式：jpg、jpeg、gif、png、bmp、ico、svg，单个图片小于10M*/) }}
          <br />
          {{ $t('pc_kng_lbl_upload_attachment_zip' /*压缩包格式：.zip、rar单个压缩包小于1G*/) }}
        </div>
        <yxt-svg
          class="hand v-mid"
          width="16px"
          height="16px"
          icon-class="icons/question-cirlce-o"
        />
      </yxt-tooltip>
    </div>

    <div
      v-for="item in list"
      :key="item.fileId || item.uuid"
      class="yxtbiz-flex-center yxtbiz-kng-operator__attachment-item"
      :class="item.status === 1 ? 'yxtbiz-kng-operator__attachment-item--error' : ''"
    >
      <yxt-svg
        class="color-gray-7"
        :remote-url="`${$staticBaseUrl}ufd/407a24/kng/pc/svg/pcsvg`"
        width="16px"
        height="16px"
        icon-class="kng_href"
      />
      <span class="yxtbiz-flex-1 yxtbiz-flex-center ml4 mr32">
        <span class="yxtbiz-mw400 ellipsis-1">{{ item.fileName }}</span>
        <yxt-tooltip
          v-if="item.serverGroupId"
          placement="top"
          :content="$t('pc_biz_kng_tip_upload_evn'/** 存储在私有云 */)">
          <yxt-svg              
            class="ml4"
            width="30px"
            height="20px"
            :remote-url="`${$staticBaseUrl}ufd/407a24/kng/pc/svg/PC`"
            icon-class="private-cloud"/>
        </yxt-tooltip>
      </span>
      <yxt-progress
        v-if="item.status === 0"
        :percentage="item.percentage"
        :stroke-width="4"
        class="yxtbiz-w195 mr20"
      ></yxt-progress>
      <span class="mr10" v-if="item.status === 1">{{ $t('pc_kng_category_lbl_importInfo_fail'/** 上传失败 */) }}</span>
      <yxt-svg
        class="color-gray-7 yxtbiz-kng-operator__attachment-delete"
        width="16px"
        height="16px"
        :remote-url="`${$staticBaseUrl}ufd/407a24/kng/pc/svg/pcsvg`"
        icon-class="kng_remove"
        @click.native="del(item)"
      />
    </div>
    <!-- 空div隔开dialog，不然附件列表不渲染 -->
    <div></div>

    <yxt-dialog
      :title="$t('pc_kng_lbl_upload_attachment'/** 上传附件 */)"
      :visible.sync="visible"
      width="480px"
      append-to-body
      >
      <div>
        <div>{{ $t('pc_biz_kng_lbl_upload_to'/** 上传到 */)}}</div>
        <yxt-radio-group v-if="mixinConfig.attachmentType === 2" v-model="uploadConfig.privateEnv">
          <yxt-radio :label="false">{{ $t('pc_kng_courseware_lbl_public_cloud'/**公有云 */) }}</yxt-radio>
          <yxt-radio :label="true">{{ $t('pc_biz_kng_tip_localCloud'/**私有云 */) }}</yxt-radio>
        </yxt-radio-group>
        <div :class="{'yxtbiz-kng-operator__server-group': mixinConfig.attachmentType === 2}" v-if="uploadConfig.privateEnv && mixinConfig.serviceGroupList.length">
          <yxt-radio-group v-model="uploadConfig.serverGroupId">
            <yxt-radio
              :label="item.id"
              :key="item.id"
              v-for="item in mixinConfig.serviceGroupList"
              >{{ item.serviceGroupName }}
            </yxt-radio>
          </yxt-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <yxt-button @click="visible = false">{{ $t('pc_biz_kng_btn_cancel'/** 取消 */)}}</yxt-button>
        <yxt-button type="primary" @click="confirm">{{ $t('pc_biz_common_btn_sure'/** 确定 */)}}</yxt-button>
      </span>
    </yxt-dialog>
  </div>
</template>

<script>
import { handleUploadFileSize } from 'yxt-biz-pc/packages/kng-operator/utils';
import { getMixinConfig, getServeGroups } from '../../../service';
import axios from 'axios';

const extension = [
  '.wmv',
  '.mp4',
  '.flv',
  '.avi',
  '.rmvb',
  '.mpg',
  '.mkv',
  '.mov',
  '.w4v',
  '.m4a',
  '.wma',
  '.wav',
  '.mp3',
  '.amr',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.xls',
  '.xlsx',
  '.pps',
  '.pdf',
  '.jpg',
  '.jpeg',
  '.gif',
  '.png',
  '.bmp',
  '.ico',
  '.svg',
  '.zip',
  '.rar'
];
const max = 50;
export default {
  name: 'form-attachment',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      filters: extension.join(','),

      // 上传配置
      uploadConfig: {
        privateEnv: false,
        serverGroupId: ''
      },
      // 混部配置
      mixinConfig: {
        enable: false,
        attachmentType: 0, // 0：公有云、1：私有云、3：手动选择
        usable: false,
        serviceGroupList: [],
        localUploadConfig: []
      },
      visible: false,
      transcodeOptions: {
        image: {
          transcode: 'N',
          private: 'Y'
        },
        video: {
          transcode: 'N',
          private: 'Y'
        },
        audio: {
          transcode: 'N',
          private: 'Y'
        },
        doc: {
          transcode: 'N',
          private: 'Y'
        },
        zip: {
          transcode: 'N',
          private: 'Y'
        }
      }
    };
  },
  computed: {
    disabled_() {
      return this.disabled || (this.list && this.list.length >= max);
    }
  },
  watch: {
    'uploadConfig.privateEnv'(val) {
      if (!val) {
        this.uploadConfig.serverGroupId = '';
      } else {
        const serviceGroupList = this.mixinConfig.serviceGroupList;
        this.uploadConfig.serverGroupId = this.uploadConfig.serverGroupId || (serviceGroupList && serviceGroupList[0].id);
      }
    }
  },
  created() {
    if (!this.list) {
      this.$emit('update:list', []);
    }
    this.setMixinConfig();
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        if (this.list && this.list.some(item => item.status === 0)) {
          this.$message.warning(this.$t('pc_biz_lbl_fileuncomplete'/** 有文件未上传完成，无法提交！ */));
          reject(new Error('attachment fail'));
        } else {
          resolve();
        }
      });
    },
    // 混部基础配置
    async setMixinConfig() {
      const [res, error] = await getMixinConfig();
      if (error) {
        return Promise.reject(new Error('error'));
      }
      const { bizSwith, localSwith } = res;
      this.mixinConfig.enable = localSwith === 1;
      this.mixinConfig.attachmentType = bizSwith && JSON.parse(bizSwith).attachment || 0;
      if (this.mixinConfig.attachmentType > 0) {
        await this.setServeGroupConfig();
        if (this.mixinConfig.attachmentType === 1) { // 只支持私有上传
          this.uploadConfig.privateEnv = true;
          this.directUpload = this.mixinConfig.serviceGroupList.length <= 1; // 只有一个服务器组
        }
      } else { // 只支持公有云上传
        this.uploadConfig.privateEnv = false;
        this.directUpload = true;
      }
    },
    // 私有云服务器配置
    async setServeGroupConfig() {
      if (this.mixinConfig.serviceGroupList.length) return;
      const [res, error] = await getServeGroups();
      if (!error) {
        const { localUploadConfig, serviceGroupList } = res;
        this.mixinConfig.serviceGroupList = serviceGroupList || [];
        this.mixinConfig.localUploadConfig = localUploadConfig;
        try {
          if (localUploadConfig && localUploadConfig.secretEndpoint) {
            await axios.get(`${localUploadConfig.secretEndpoint}/receive/check`);
            this.mixinConfig.usable = true;
          }
        } catch (error) {

        }
      }
    },
    confirm() {
      this.visible = false;
      this.startUpload();
    },
    clickUpload() {
      if (this.list && this.list.find(item => item.status === 0)) {
        this.$message.error(this.$t('pc_kng_biz_lbl_uploading'/** 上传中，请稍等 */));
        return;
      }

      if (this.directUpload) {
        this.startUpload();
      } else {
        this.visible = true;
      }
    },
    startUpload() {
      this.$nextTick(() => {
        if (this.uploadConfig.privateEnv) {
          if (!this.mixinConfig.usable) {
            return this.$message.error(this.$t('pc_kng_courseware_tip_connect_to_server'/** 无法连接到服务器，如需访问请联系管理人员，检查服务器是否启动 */));
          }
          this.$refs.bizPrivateUpload.$el.querySelector('input').click();
        } else {
          this.$refs.bizUpload.$el.querySelector('input').click();
        }
      });
    },
    filesAdded(fileList) {
      fileList.forEach(file => {
        this.setFile(file);
      });
    },
    setFile(file) {
      if (!extension.includes(file.extension.toLowerCase())) {
        file.abort();
        return this.$message.error(this.$t('pc_kng_upload_tip_file_type_no_match'/** 上传文件类型不符合要求！ */));
      }
      if (file.error === 'oversize') {
        return this.$message.error(this.$t('pc_kng_relatedSetting_msg_filesizelimit', {val: handleUploadFileSize(file.size / 1024)[0]}));
      } else if (file.error === 'forbidden') {
        return this.$message.error(this.$t('pc_kng_upload_tip_file_type_no_match'/** 上传文件类型不符合要求！ */));
      }
      if (this.list && this.list.length >= max) {
        file.abort();
        return;
      }
      this.list.push({
        fileName: file.name,
        percentage: 0,
        uuid: file.uuid,
        fileType: file.fileType,
        fileSize: file.size,
        extension: file.extension,
        serverGroupId: this.uploadConfig.serverGroupId,
        status: 0
      });
    },
    onProgress(file, progress) {
      const obj = this.list.find(item => item.uuid === file.uuid);
      if (obj) {
        this.$set(obj, 'percentage', parseInt(progress * 100, 10));
        obj.abort = file.abort;
      }
    },
    onUploaded(file) {
      const obj = this.list.find(item => item.uuid === file.uuid);
      if (obj) {
        this.$set(obj, 'fileId', file.id);
        this.$set(obj, 'status', undefined);
        obj.abort = undefined;
      }
    },
    onError(_, file) {
      const obj = this.list.find(item => item.uuid === file.uuid);
      if (obj) {
        this.$set(obj, 'status', 1);
        obj.abort = undefined;
      }
    },
    del(file) {
      file.abort && file.abort();
      const index = this.list.findIndex(item => file === item);
      index > -1 && this.list.splice(index, 1);
    }
  }
};
</script>